module.exports = __webpack_public_path__ + "static/DrJava.47f94a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/commercial/DrJava.jpg
// module id = 143
// module chunks = 35783957827783 202660965941462